// extracted by mini-css-extract-plugin
module.exports = {"inlineDate":"Date_inlineDate__v2619"};